import { createRouter, createWebHistory } from "vue-router";
import Cookies from "js-cookie";
const isTokenValid = () => {
  const token = Cookies.get("token");
  if (!token) return false;

  try {
    const { exp } = JSON.parse(atob(token.split(".")[1])); // Decodifica el payload del JWT
    return Date.now() < exp * 1000; // Compara con la hora actual
  } catch (error) {
    return false; // Si no se puede decodificar, el token es inválido
  }
};

const getUserRole = () => {
  const cookieRole = Cookies.get("rol");
  if (cookieRole) return String(cookieRole).toLowerCase();

  const token = Cookies.get("token");
  if (!token) return null;
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    const raw =
      payload.rol
        (Array.isArray(payload.roles) ? payload.roles[0] : null);
    return raw ? String(raw).toLowerCase() : null;
  } catch {
    return null;
  }
};

// Guardia de autenticación reutilizable
const authGuard = (to, from, next) => {
  if (!isTokenValid()) {
    return next({ path: "/ingresar", query: { redirect: to.fullPath } });
  }

  const allowedRoles = to.matched
    .map(r => r.meta?.allowedRoles)
    .filter(Boolean)
    .flat();

  if (!allowedRoles.length) return next(); 

  const role = getUserRole();
  if (!role || !allowedRoles.includes(role)) {
    return next({
      path: "/dashboard",                   
      query: {
        noAuth: "1",
        required: allowedRoles.join(","), 
      },
    });
  }

  next();
};
const routes = [
  {
    path: "/",
    name: "Inicio",
    component: () => import("../views/Inicio.vue"),
  },
  {
    path: "/como-funciona",
    name: "comoFunciona",
    component: () => import("../views/ComoFunciona.vue"),
  },
  {
    path: "/precios",
    name: "precios",
    component: () => import("../views/Precios.vue"),
  },
  {
    path: "/privacy-policy",
    name: "privacyPolicy",
    component: () => import("../views/PrivacyPolicy.vue"),
  },
  {
    path: "/delete-account",
    name: "deleteAccount",
    component: () => import("../views/DeleteAccount.vue"),
  },
  {
    path: "/terms-and-conditions",
    name: "termsAndConditions",
    component: () => import("../views/TermsAndConditions.vue"),
  },
  {
    path: "/ingresar",
    component: () => import("../views/EstructuraIngreso.vue"),
    children: [
      {
        path: "",
        name: "ingresar",
        component: () => import("../components/Ingresar.vue"),
      },
      {
        path: "registrarse",
        name: "registrarse",
        component: () => import("../components/Registrarse.vue"),
        alias: "/registrarse",
      },
      {
        path: "registrar-campo",
        name: "registrarCampo",
        component: () => import("../components/RegistrarCampo.vue"),
        alias: "/registrar-campo",
        props: (route) => ({
          datosRegistro: JSON.parse(
            decodeURIComponent(route.query.datosRegistro || "{}")
          ),
        }),
      },
    ],
  },
  {
    path: "/dashboard",
    name: "dashboard",
    component: () => import("../views/Dashboard.vue"),
    beforeEnter: authGuard,
    meta: { requiereSuscripcion: true },
    redirect: () => {
      return { name: "dashboardPrincipal" };
    },
    children: [
      {
        path: "/dashboardPrincipal",
        name: "dashboardPrincipal",
        component: () => import("../components/DashboardPrincipal.vue"),
      },
      {
        path: "/potreros",
        name: "potreros",
        component: () => import("../components/Potreros.vue"),
      },
      {
        path: "/datos",
        name: "datos",
        component: () => import("../components/Datos.vue"),
      },
      {
        path: "/integrantes",
        name: "integrantes",
        component: () => import("../components/Integrantes.vue"),
      },
      {
        path: "/mapa",
        name: "mapa",
        component: () => import("../components/Mapa.vue"),
      },
      {
        path: "/calendario",
        name: "calendario",
        component: () => import("../components/Calendario.vue"),
      },
    ],
  },
  {
    path: "/suscripciones",
    name: "suscripciones",
    component: () => import("../views/Suscripciones.vue"),
    beforeEnter: authGuard,
    alias: "/suscripciones"
  },
  {
    path: "/panelAdmin",
    name: "superadmin",
    component: () => import("../views/SuperAdmin.vue"),
    alias: "/panel-admin",
    beforeEnter: authGuard,
    meta: { requiresAuth: true, allowedRoles: ["superadmin"] },
    redirect: () => {
      return { name: "usuarios" };
    },
    children: [
      {
        path: "/usuarios",
        name: "usuarios",
        component: () => import("../components/superAdmin/Usuarios.vue"),
      },
      {
        path: "/campos",
        name: "campos",
        component: () => import("../components/superAdmin/Campos.vue"),
      },
      {
        path: "/pagos",
        name: "pagos",
        component: () => import("../components/superAdmin/Pagos.vue"),
      },
      {
        path: "/calendarioSuperAdmin",
        name: "calendarioSuperAdmin",
        component: () =>
          import("../components/superAdmin/CalendarioSuperAdmin.vue"),
      }
    ],
  },
  {
    path: "/no-autorizado",
    name: "noAutorizado",
    component: { template: '<div style="padding:2rem">No autorizado</div>' },
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return new Promise((resolve) => {
        setTimeout(() => {
          const element = document.querySelector(to.hash);
          if (element) {
            element.scrollIntoView({ behavior: "smooth" });
          }
          resolve();
        }, 400);
      });
    } else {
      return new Promise((resolve) => {
        setTimeout(() => {
          window.scrollTo(0, 0);
          resolve();
        }, 400);
      });
    }
  },
});

export default router;
